import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

// Auto-grow textareas as content grows; never shrink below a manually dragged height.
const growTextarea = (e) => {
  const el = e.target;
  if (el.tagName !== "TEXTAREA") return;
  if (el.scrollHeight > el.clientHeight) el.style.height = `${el.scrollHeight + 2}px`;
};
document.addEventListener("input", growTextarea, true);
document.addEventListener("focusin", growTextarea, true);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
